import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { PersistGate } from "redux-persist/integration/react";
import allReducers from "./Redux/Reducers/Index";
import { GoogleOAuthProvider } from '@react-oauth/google';

const persistConfig = {
  key: "Todo",
  storage,
  whitelist: ["myTodo"], // only navigation will be persisted
};

const persistedReducer = persistReducer(persistConfig, allReducers);

const store = createStore(persistedReducer);

const persistor = persistStore(store);

store.subscribe(() => console.log(store.getState()));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
       <GoogleOAuthProvider clientId="598675054866-091husa3s0kc4t64287hfk5avsburjj5.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
